import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "JUSTIFICATE_TRANSPORT_" }
);

export interface JustificateTransportState extends IState {}

const INITIAL_STATE: JustificateTransportState = {
  loading: false,
  error: null,
};

const request = (state: JustificateTransportState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: JustificateTransportState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: JustificateTransportState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const justificateTransport = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const JustificateTransportTypes = Types;
export const JustificateTransportActions = Creators;
